<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import {notifyModel} from "@/models/notifyModel";
import {apiClient} from "@/state/modules/apiClient";
import LetterCube from "@/components/LetterCube.vue";
import {userModel} from "@/models/userModel";

export default {
  page: {
    title: "Quản lý sinh viên",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    LetterCube,
    // LetterCube,
    Layout,
    Multiselect,
  },
  data() {
    return {
      title: "Quản lý sinh viên",
      fields: [
        {key: 'STT', label: 'STT', class: 'td-stt', sortable: false, thClass: 'hidden-sortable'},
        {
          key: "userName",
          label: "Tài khoản",
          class: 'td-username',
          sortable: true,
          thClass: 'hidden-sortable',
          thStyle: "text-align:center; min-width: 150px;"
        },
        {
          key: "fullName",
          label: "Họ và tên",
          class: 'td-ten',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'td-xuly',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 100px;"
        }
      ],
      fieldsMentor: [
        {key: 'STT', label: 'STT', class: 'td-stt', sortable: false, thClass: 'hidden-sortable'},
        {
          key: "userName",
          label: "Tài khoản",
          class: 'td-username',
          sortable: true,
          thClass: 'hidden-sortable',
          thStyle: "text-align:center; min-width: 150px;"
        },
        {
          key: "fullName",
          label: "Họ và tên",
          class: 'td-ten',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'td-xuly',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 100px;"
        }
      ],
      optionKhoa: [],
      optionLop: [],
      optionsCoVan: [],
      khoa: null,
      lop: null,
      pagingStudent: {
        perPage: 20,
        pageOptions: [20, 50, 80, 100],
        numberOfElement: 0,
        totalRows: 0,
        todoTotalRows: 0,
        currentPage: 1,
        isBusy: false
      },
      pagingMentor: {
        perPage: 20,
        pageOptions: [20, 50, 80, 100],
        numberOfElement: 0,
        totalRows: 0,
        todoTotalRows: 0,
        currentPage: 1,
        isBusy: false
      },
      showModal: false,
      showDeleteModal: false,
      model: userModel.baseJson(),
      submitted: false,
      mentor: {
        lop: null,
        mentor: null
      },
      showModalMentor: false,
      isMentor: false
    };
  },
  validations: {
    model: {
      userName: {required},
      firstName: {required},
      lastName: {required},
    },
    mentor: {
      mentor: {required},
      lop: {required},
    },
  },
  mounted() {
  },
  computed: {},
  watch: {
    khoa: {
      deep: true,
      async handler(val) {
        await this.getLop(val.id);
      }
    },
    lop: {
      deep: true,
      async handler(val) {
       this.fnGetList()
        this.getCoVan()
      }
    }
  },
  async created() {
    this.getKhoa();
  },
  methods: {
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    async fnGetListMentor() {
      this.$refs.tblListMentor?.refresh()

    },
    async getKhoa() {
      await apiClient.get("donvi/get-khoa").then(res => {
        console.log("Res", res)
        if (res.resultCode == "SUCCESS") {
          let items = res.data
          this.optionKhoa = items;
        }
        return [];
      });
    },
    async getLop(id) {
      if (id) {
        await apiClient.get("donvi/get-lop/" + id).then(res => {
          if (res.resultCode == "SUCCESS") {
            let items = res.data
            this.optionLop = items;
          }
          return [];
        });
      } else {
        this.optionLop = []
      }
    },
    async getCoVan() {
      if (this.khoa) {
        await apiClient.get("students/get-covan/" + this.khoa.id).then(res => {
          if (res.resultCode == "SUCCESS") {
            let items = res.data
            this.optionsCoVan = items;
          }
          return [];
        });
      } else {
        this.optionsCoVan = []
      }
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        lop: this.lop,
      }
      this.loading = true

      try {
        if (this.khoa && this.lop) {
          let promise =    apiClient.post("users/get-paging-params-student", params);
          return promise.then(res => {
            if (res.resultCode == "SUCCESS") {
              let items = res.data.data
              this.pagingStudent.totalRows = res.data.totalRows
              this.pagingStudent.numberOfElement = items.length
              this.loading = false
              console.log("items", items)
              return items || []
            }
            return [];
          });
        }
      } finally {
        this.loading = false
      }
    },
    myProviderMentor(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        lop: this.lop,
      }
      this.loading = true

      try {
        if (this.khoa && this.lop) {
          let promise = apiClient.post("students/get-paging-params-mentor", params);
          return promise.then(res => {
            if (res.resultCode == "SUCCESS") {
              let items = res.data.data
              if(items){
                this.pagingMentor.totalRows = res.data.totalRows
                this.pagingMentor.numberOfElement = items.length
                this.loading = false
                return items || []
              }
            }
            this.pagingMentor.totalRows =  0
            this.pagingMentor.numberOfElement = 0
            return [];
          });
        }
      } finally {
        this.loading = false
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });

        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await apiClient.post("students/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = userModel.baseJson();
              this.$refs.tblList.refresh();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          this.model.donVi = this.lop;
          // Create model
          await apiClient.post("students/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetList();
              this.showModal = false;
              this.model = userModel.baseJson();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleCreateMentor(e) {
      e.preventDefault();
      this.mentor.lop = this.lop;
      this.submitted = true;
      console.log(this.$v)
      this.$v.mentor.$touch();
      if (this.$v.mentor.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });

        // Create model
        await apiClient.post("students/create-mentor", this.mentor).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetListMentor();
            this.showModalMentor = false;
            this.mentor =  {
              lop: null,
              mentor: null
            };
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
      }
      this.submitted = false;
    },
    handleShowDeleteModal(id, mentor) {
      this.model.id = id;
      this.isMentor = mentor;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        if(this.isMentor){
          await apiClient.post("students/delete-mentor",{mentorId: this.model.id, lop: this.lop}).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetListMentor();
              this.showDeleteModal = false;
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }else {
          await apiClient.post("students/delete/" +this.model.id,null).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetList();
              this.showDeleteModal = false;
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }

      }
    },
    async handleUpdate(id) {
      await this.$store.dispatch("userStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = userModel.toJson(res.data);
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                  <!-- Đơn vị soạn-->
                  <div class="flex-grow-1 me-2">
                    <label>Khoa</label>
                    <multiselect
                        v-model="khoa"
                        :options="optionKhoa"
                        track-by="id"
                        label="ten"
                        placeholder="Chọn khoa"
                        deselect-label="Nhấn để xoá"
                        selectLabel="Nhấn enter để chọn"
                        selectedLabel="Đã chọn"
                    ></multiselect>
                  </div>
                  <div class="flex-grow-1 me-2">
                    <label>Lớp</label>
                    <multiselect
                        v-model="lop"
                        :options="optionLop"
                        track-by="id"
                        label="ten"
                        placeholder="Chọn lớp"
                        deselect-label="Nhấn để xoá"
                        selectLabel="Nhấn enter để chọn"
                        selectedLabel="Đã chọn"
                    ></multiselect>
                  </div>
                  <!--  Xử lý -->
                  <!--                  <div class="flex-grow-0 ms-2">-->
                  <!--                    <div class="d-flex justify-content-between align-items-center flex-wrap">-->
                  <!--                      <div class="flex-grow-1 mt-xl-0 mt-2">-->
                  <!--                        <b-button @click="handleSearch" variant="light"-->
                  <!--                                  class="btn w-md btn-primary me-2" size="md">-->
                  <!--                          <i class="fas fa-search align-middle me-2"></i>-->
                  <!--                          Tìm kiếm-->
                  <!--                        </b-button>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div v-if="lop" class="card-body">
            <div class="row" style="margin-bottom: 10px">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-tabs content-class="" nav-class="cs-tabs">
                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                        <span class="d-none d-sm-inline-block">Sinh viên</span>
                      </div>
                    </template>
                    <div>
                      <div class="col-md-8 col-12" style="margin: 10px 0px">
                        <b-button
                            type="button"
                            variant="primary"
                            class="w-md"
                            size="sm"
                            @click="showModal = true"
                        >
                          <i class="mdi mdi-plus me-1"></i> Thêm sinh viên
                        </b-button>
                      </div>
                      <div class="table-responsive mb-0">
                        <b-table
                            class="datatables"
                            :items="myProvider"
                            :fields="fields"
                            striped
                            bordered
                            responsive="md"
                            :per-page="pagingStudent.perPage"
                            :current-page="pagingStudent.currentPage"
                            ref="tblList"
                            primary-key="id"
                            :busy.sync="pagingStudent.isBusy"
                        >
                          <template v-slot:cell(STT)="data">
                            {{ data.index + ((pagingStudent.currentPage - 1) * pagingStudent.perPage) + 1 }}
                          </template>
                                                    <template v-slot:cell(process)="data">
                                                      <button
                                                          type="button"
                                                          size="sm"
                                                          class="btn btn-edit btn-sm"
                                                          v-on:click="handleUpdate(data.item.id)">
                                                        <i class="fas fa-pencil-alt"></i>
                                                      </button>
                                                      <button
                                                          type="button"
                                                          size="sm"
                                                          class="btn btn-delete btn-sm"
                                                          v-on:click="handleShowDeleteModal(data.item.id, false)">
                                                        <i class="fas fa-trash-alt"></i>
                                                      </button>
                                                    </template>
                        </b-table>
                        <template v-if="pagingStudent.isBusy">
                          <div align="center">
                            <LetterCube></LetterCube>
                          </div>
                        </template>
                        <template v-if="pagingStudent.totalRows <= 0 && !pagingStudent.isBusy">
                          <div align="center">Không có dữ liệu</div>
                        </template>
                      </div>

                      <div class="row">
                        <b-col>
                          <div>Hiển thị {{ pagingStudent.numberOfElement }} trên tổng số {{ pagingStudent.totalRows }}
                            dòng
                          </div>
                        </b-col>
                        <div class="col">
                          <div
                              class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0">
                              <!-- pagination -->
                              <b-pagination
                                  v-model="pagingStudent.currentPage"
                                  :total-rows="pagingStudent.totalRows"
                                  :per-page="pagingStudent.perPage"
                              ></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>

                    </div>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="far fa-user"></i>
                                        </span>
                        <span class="d-none d-sm-inline-block"> Cố vấn</span>
                      </div>

                    </template>
                    <div>
                      <div class="col-md-8 col-12" style="margin: 10px 0px">
                        <b-button
                            type="button"
                            variant="primary"
                            class="w-md"
                            size="sm"
                            @click="showModalMentor = true"
                        >
                          <i class="mdi mdi-plus me-1"></i> Thêm cô vấn
                        </b-button>
                      </div>
                      <div class="table-responsive mb-0">
                        <b-table
                            class="datatables"
                            :items="myProviderMentor"
                            :fields="fieldsMentor"
                            striped
                            bordered
                            responsive="md"
                            :per-page="pagingMentor.perPage"
                            :current-page="pagingMentor.currentPage"
                            ref="tblListMentor"
                            primary-key="id"
                            :busy.sync="pagingMentor.isBusy"
                        >
                          <template v-slot:cell(STT)="data">
                            {{ data.index + ((pagingMentor.currentPage - 1) * pagingMentor.perPage) + 1 }}
                          </template>
                          <template v-slot:cell(process)="data">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-delete btn-sm"
                                v-on:click="handleShowDeleteModal(data.item.id, true)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </template>
                        </b-table>
                        <template v-if="pagingMentor.isBusy">
                          <div align="center">
                            <LetterCube></LetterCube>
                          </div>
                        </template>
                        <template v-if="pagingMentor.totalRows <= 0 && !pagingMentor.isBusy">
                          <div align="center">Không có dữ liệu</div>
                        </template>
                      </div>

                      <div class="row">
                        <b-col>
                          <div>Hiển thị {{ pagingMentor.numberOfElement }} trên tổng số {{ pagingMentor.totalRows }}
                            dòng
                          </div>
                        </b-col>
                        <div class="col">
                          <div
                              class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0">
                              <!-- pagination -->
                              <b-pagination
                                  v-model="pagingMentor.currentPage"
                                  :total-rows="pagingMentor.totalRows"
                                  :per-page="pagingMentor.perPage"
                              ></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>

                    </div>

                  </b-tab>
                </b-tabs>

              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> Không có dữ liệu </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
        v-model="showModal"
        title="Thông tin sinh viên"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        centered
        no-close-on-backdrop
        size="lg"
    >
      <form @submit.prevent="handleSubmit"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Tên tài khoản</label>
              <span style="color: red">&nbsp;*</span>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="userName"
                  v-model.trim="model.userName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập tài khoản"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.userName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.userName.required"
                  class="invalid-feedback"
              >
                Tên tài khoản không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Mật khẩu</label>
              <input
                  id="password"
                  v-model="model.password"
                  type="password"
                  class="form-control"
                  placeholder="Nhập mật khẩu"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Họ</label>
              <span style="color: red">&nbsp;*</span>
              <input
                  id="lastName"
                  v-model="model.lastName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập họ"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.lastName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.lastName.required"
                  class="invalid-feedback"
              >
                Họ không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Tên</label>
              <span style="color: red">&nbsp;*</span>
              <input
                  id="firstName"
                  v-model="model.firstName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập tên"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.firstName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.firstName.required"
                  class="invalid-feedback"
              >
                Tên không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Số điện thoại</label>
              <input
                  id="phoneNumber"
                  v-model="model.phoneNumber"
                  type="text"
                  class="form-control"
                  placeholder="Nhập số điện thoại"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Email</label>
              <input
                  id="email"
                  v-model="model.email"
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  class="form-control"
                  placeholder="Nhập email"
              />
            </div>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="showModal = false">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md">Lưu
          </b-button>
        </div>
      </form>
    </b-modal>
    <b-modal
        v-model="showDeleteModal"
        centered
        title="Xóa dữ liệu"
        title-class="font-18"
        no-close-on-backdrop
    >
      <p>
        Dữ liệu xóa sẽ không được phục hồi!
      </p>
      <template #modal-footer>
        <button v-b-modal.modal-close_visit
                class="btn btn-outline-info m-1"
                v-on:click="showDeleteModal = false">
          Đóng
        </button>
        <button v-b-modal.modal-close_visit
                class="btn btn-danger btn m-1"
                v-on:click="handleDelete">
          Xóa
        </button>
      </template>
    </b-modal>
    <b-modal
        v-model="showModalMentor"
        title="Thông tin cố vấn"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        centered
        no-close-on-backdrop
        size="md"
    >
      <form @submit.prevent="handleCreateMentor"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="mb-1"> Giảng viên</label>
              <multiselect v-model="mentor.mentor" :options="optionsCoVan" track-by="id" label="fullName"
                           placeholder="Chọn người gửi" deselect-label="Nhấn để xoá"
                           selectLabel="Nhấn enter để chọn"
                           selectedLabel="Đã chọn"
                           :class="{
                                'is-invalid':
                                  submitted && $v.mentor.mentor.$error,
                              }"
              >

                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.fullName }}</strong>

                  <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                    <span v-if="option.donVi" class="option__small"
                          style="color:green">{{ option.donVi.ten }}</span>
                  </div>
                </template>

              </multiselect>
              <div
                  v-if="submitted && !$v.mentor.mentor.required"
                  class="invalid-feedback"
              >
                Cố vấn không được trống.
              </div>

            </div>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="showModalMentor = false">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md">Lưu
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<style>
.td-stt {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 130px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.ck-editor__editable {
  min-height: 100px !important;
}

.ck-content {
  height: 100px !important;
}

.customAddElement {
  position: absolute;
  top: 8px;
  left: -20px;
}

.custom-ribon {
  position: absolute;
  width: 130px;
  top: 15px;
  left: -15px;
}

.custom-ribon > div {
  border-radius: 3px;
}

.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  padding: 5px;
  color: #00568C;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.show-detail-vbd {
  background-color: #e6f0fb;
  border: 1px solid #e6f0fb;
  border-radius: 5px;
  margin: 10px;
}

@media only screen and (max-width: 768px) {
  .show-detail-vbd {
    margin: 0px;
  }
}

.show-detail-vbd .card-body {
  padding: 0;
}

.show-detail-vbd .card-body .nav-tabs .nav-link {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border: none;
  background: transparent;
  color: #055E8F;
  border-radius: 5px;
}

.show-detail-vbd .card-body .nav-tabs .nav-link.active {
  background: #055E8F;
  color: #fff;
}

.show-detail-vbd .card-body .nav-tabs {
  border-bottom: none;
}

.text-black-2a {
  color: #2a2a2a;
}

.text-black {
  color: #000;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.file-box {
  justify-content: start;
}

.cs-table-vbden {
  min-height: 300px;
}

@media only screen and (max-width: 768px) {

  /* Force table to not be like tables anymore */
  .cs-table-vbden table,
  .cs-table-vbden thead,
  .cs-table-vbden tbody,
  .cs-table-vbden th,
  .cs-table-vbden td,
  .cs-table-vbden tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .cs-table-vbden thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .cs-table-vbden tr {
    border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .cs-table-vbden .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .cs-table-vbden .table-bordered {
    border: none;
  }

  .cs-table-vbden .table-bordered th:first-child,
  .cs-table-vbden .table-bordered td:first-child {
    border-top: none;
  }

  .cs-table-vbden .table-bordered th,
  .cs-table-vbden .table-bordered td {
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  .b-table-vbden > td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  .b-table-details.b-table-vbden > td {
    padding-left: 0% !important;
  }

  .cs-table-vbden td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .b-table-vbden .btn-process {
    padding: 0px !important;
  }

  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  .file-box {
    flex-direction: column;
  }

  /*
  Label the data
  */
  .b-table-vbden > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(2):before {
    content: "Số Lưu CV";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(3):before {
    content: "Số VB đến";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(4):before {
    content: "Trích yếu";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(5):before {
    content: "Trạng thái";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(6):before {
    content: "Hạn xử lý";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(7):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(8):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

@media only screen and (max-width: 768px) {
  .b-table-vbden > td {
    padding-left: 95px !important;
  }
}


.cs-close-tabs {
  position: relative;
}

.item-close-tabs {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-close-tabs:hover {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  width: 30px;
  height: 30px;
}

.item-icon {
  transform: rotate(135deg);
  color: #fff;
  width: 24px;
  height: 26px;
  position: absolute;
  top: 1px;
  right: -1px;
}

.cs-modal-header {
  background-color: #f2f6fc;
  border: none;
}

.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}

.activity-feed .feed-item {
  border-left: 2px dotted #e9ecef;
}

.feed-item-red:after {
  background: #ec4461 !important;
}
</style>
